
// packages
import React, { useState, useEffect, useMemo } from 'react';
import { Box, Stack, Typography, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

//local
import AllUsersTableTile from "../widgets/AllUsersTableTile";
import SingleUserTile from "../widgets/SingleUserTile";
import RetakeUsersTile from '../widgets/RetakeUsersTile';
import { getNeedsRetake } from '../helpers/getNeedsRetake';
import { getUsers } from "../helpers/requestUsers";


const UsersAll = () => {
    
    const [users, setUsers] = useState([]);
    const [singleUser, setSingleUser] = useState(null);

    useMemo(() => {
        getUsers(null, setUsers)
    }, [setUsers])

    const [retakeUsers, setRetakeUsers] = useState([]);


    return (
        <Stack spacing={3} sx={{width: '80%'}}>
            
            <SingleUserTile user_data={singleUser}/>
            <RetakeUsersTile rows={retakeUsers} onRowClick={setSingleUser} onHeaderClick={() => getNeedsRetake(setRetakeUsers)}/>
            <AllUsersTableTile rows={users} onRowClick={setSingleUser} />
            
        </Stack>
    )
};

export default UsersAll;